export default __webpack_public_path__ + "static/monitor_w.73cd2ebec53a7891886981a51a86d085.png";